__turbopack_context__.v({
  "contactInfo": "commercialFooterV2Style-module-scss-module__dtOwWG__contactInfo",
  "copyright": "commercialFooterV2Style-module-scss-module__dtOwWG__copyright",
  "footer": "commercialFooterV2Style-module-scss-module__dtOwWG__footer",
  "footerBottom": "commercialFooterV2Style-module-scss-module__dtOwWG__footerBottom",
  "footerContent": "commercialFooterV2Style-module-scss-module__dtOwWG__footerContent",
  "legalLinks": "commercialFooterV2Style-module-scss-module__dtOwWG__legalLinks",
  "legalText": "commercialFooterV2Style-module-scss-module__dtOwWG__legalText",
  "logo": "commercialFooterV2Style-module-scss-module__dtOwWG__logo",
  "navigation": "commercialFooterV2Style-module-scss-module__dtOwWG__navigation",
  "socialMedia": "commercialFooterV2Style-module-scss-module__dtOwWG__socialMedia",
});
